import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DeletePincode,
  GetAllPincode,
  StatusPincode,
} from "../../../../../../features/admin/masters/pincode/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.masters.pincode);
  // const all_country = useSelector((state) => state.common.all_country);
  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = country?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAllPincode({
        name: name,
        page: page,
        per_page: country?.per_page,
      })
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(DeletePincode(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(StatusPincode(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
